import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSwapVertical = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M11 6a1.5 1.5 0 0 0-2.56-1.06l-4 4A1.5 1.5 0 0 0 5.5 11.5H8V18a1.5 1.5 0 1 0 3 0zM16 6v6.5h2.5a1.5 1.5 0 0 1 1.06 2.56l-4 4A1.5 1.5 0 0 1 13 18V6a1.5 1.5 0 0 1 3 0'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSwapVertical)
export default ForwardRef
